export default class PedidoDetalhesViewModel {
	constructor () {
		this.PedidoId = undefined;
		this.ProdutoId = undefined;
		this.OrcamentoId = undefined;
		this.LoteFreteId = undefined;
		this.CidadeId = undefined;
		this.NomeProduto = undefined;
		this.NomeTransportadora = undefined;
		this.DataUltimoFaturamentoFormatada = undefined;
		this.DataUltimaVendaFormatada = undefined;
		this.DataDigitacaoFormatada = undefined;
		this.Ipi = undefined;
		this.EmLinha = undefined;
		this.Fsc = undefined;
		this.CodigoProduto = undefined;
		this.PrecoTotalSemIPIFormatado = undefined;
		this.Critica1 = undefined;
		this.Critica2 = undefined;
		this.Critica3 = undefined;
		this.Critica4 = undefined;
		this.Critica5 = undefined;
		this.NomeCidade = undefined;
		this.CodigoExterno = undefined;
		this.CodigoPedido = undefined;
		this.NumeroQuantidadeTotalFormatado = undefined;
		this.ValorPrecoFinal = undefined;
		this.PorcentagemComissaoVenda = undefined;
		this.PorcentagemComissaoRepresentante = undefined;
		this.CondicaoPagamento = undefined;
		this.CodigoAcesso = undefined;
		this.MedidaPapelSeda = undefined;
        this.EnviarPapelSedaDescricao = undefined;
		this.QuantidadeProduzida = undefined;
		this.PrecoFormatado = undefined;
		this.quantidade = undefined;
		this.QuantidadeExpedida = undefined;
		this.QuantidadeExpandida = undefined;
		this.ObservacaoDefinicao = undefined;
		this.ProgramacaoKanban = undefined;
		this.ObservacaoGeral = undefined;
		this.NumeroOrcamento = undefined;
		this.LiberadoParaProduzir = undefined;
		this.DescricaoFaseProduto = undefined;
		this.EmbalagemEspecificaCaixaColetiva = undefined;
		this.QuantidadeFolhas = undefined;
		this.NumeroOrdemDeCompra = undefined;
		this.EmbalagemEspecificaFilmeEncolhivel = undefined;
		this.EmbalagemEspecificaPalete = undefined;
		this.EmbalagemOutros = undefined;
		this.IndicadorDeTipoFreteEnum = undefined;
		this.DataEntregaFormatada = undefined;
		this.DataCarregamentoFormatada = undefined;
		this.ComponenteTipoEnumTexto = undefined;
		this.StatusTexto = undefined;
		this.StatusPedidoTexto = undefined;
		this.StatusPedidoParcelaTexto = undefined;
		this.Exportacao = undefined;
		this.ImpressaoDescricao = undefined;
		this.DescricaoVisual = undefined;
		this.FacaMedidaDescricao = undefined;
		this.FacaSistemaDescricao = undefined;
		this.ObservacaoGeral = undefined;
		this.NumeroParcela = undefined;
		this.PrecoMRFormatado = undefined;
	}
}